import React from "react"
import { IconColorsType } from "../"
import { camelize } from "../../utils"
import cx from "classnames"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "searchCar"
const SearchCarIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    }
  )
  const wrap = (content: React.ReactNode) => (
    <span className={computedClassName}>{content}</span>
  )
  return wrap(
    <svg
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      style={{
        fillRule: "evenodd",
        clipRule: "evenodd",
        strokeLinejoin: "round",
        strokeMiterlimit: 2,
      }}
    >
      <path
        d="M15.695 18.052a9.895 9.895 0 0 1-5.753 1.833C4.451 19.885 0 15.434 0 9.942 0 4.451 4.451 0 9.942 0c5.492 0 9.943 4.451 9.943 9.942a9.9 9.9 0 0 1-1.833 5.754l5.653 5.654a1 1 0 0 1 0 1.414l-.943.943a.999.999 0 0 1-1.414 0l-5.653-5.655Zm-.496-10.179C14.904 6.341 14.141 5 12.171 5H7.886c-1.97 0-2.733 1.341-3.028 2.873A1.072 1.072 0 1 0 4.671 10h.004c-.004.25-.004.49-.004.714v3.57c0 .403.323.716.721.716h1.416a.715.715 0 0 0 .721-.716v-.713h5v.713c0 .403.322.716.721.716h1.415a.715.715 0 0 0 .721-.716v-3.57c0-.224 0-.464-.004-.714h.004a1.072 1.072 0 1 0-.187-2.127Zm-1.309.917c.017.168.03.327.04.496H6.127c.01-.169.023-.328.04-.496.175-1.699.635-2.361 1.719-2.361h4.285c1.084 0 1.544.662 1.719 2.361Zm-7.076 3.531a.892.892 0 1 1-.001-1.785.892.892 0 0 1 .001 1.785Zm6.429 0a.892.892 0 1 1-.001-1.785.892.892 0 0 1 .001 1.785Z"
        style={{
          fillRule: "nonzero",
        }}
      />
    </svg>
  )
}
export default SearchCarIcon
